import React, { useState, useEffect } from "react";
import Footer from "./Footer";
import FooterMobile from "./Footer_mobile";

const FooterWrapper = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    // Check on initial load
    checkScreenSize();

    // Add event listener
    window.addEventListener("resize", checkScreenSize);

    // Clean up event listener
    return () => {
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  return (
    <>
      {isMobile ? <FooterMobile /> : <Footer />}
    </>
  );
};

export default FooterWrapper;